import React from "react";
import { useNavigate } from "react-router-dom";
import LegalFooter from "../components/LegalFooter";

// The desktop app is organiser-only -- there's no concept of a Player
// Portal on a single offline machine, so that choice is hidden entirely
// there rather than just discouraged.
const isElectron = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes("electron");

export default function ChooseLogin() {
  const navigate = useNavigate();

  const card = (emoji, title, subtitle, btnText, btnAction, btnSecondary, btnSecondaryAction, color) => (
    <div style={{ background: "white", borderRadius: "12px", padding: "28px 24px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", flex: 1, minWidth: "220px", maxWidth: "280px" }}>
      <div style={{ fontSize: "48px" }}>{emoji}</div>
      <div style={{ fontWeight: "800", fontSize: "16px", color: "#14532d", textAlign: "center" }}>{title}</div>
      <div style={{ fontSize: "12px", color: "#6b7280", textAlign: "center", lineHeight: "1.6" }}>{subtitle}</div>
      <button onClick={btnAction}
        style={{ width: "100%", background: color, color: "white", border: "none", borderRadius: "8px", padding: "11px", fontSize: "14px", fontWeight: "700", cursor: "pointer", marginTop: "4px" }}>
        {btnText}
      </button>
      {btnSecondary && (
        <button onClick={btnSecondaryAction}
          style={{ width: "100%", background: "none", border: "1px solid #d1d5db", borderRadius: "8px", padding: "9px", fontSize: "13px", color: "#6b7280", cursor: "pointer" }}>
          {btnSecondary}
        </button>
      )}
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: "#f0fdf4", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "24px" }}>
      <div style={{ textAlign: "center", marginBottom: "36px" }}>
        <div style={{ width: "72px", height: "72px", background: "#14532d", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: "32px" }}>⛳</div>
        <h1 style={{ fontSize: "26px", fontWeight: "800", color: "#14532d", margin: "0 0 6px" }}>Golf Society Manager</h1>
        <p style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>Choose how you want to sign in</p>
      </div>

      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "center", maxWidth: "900px" }}>
        {!isElectron && card("🏌️", "Player Portal", "View your results, verify a playing partner's scorecard and track your HCP review status.", "Player Login", () => navigate("/player/login"), "New player? Register here", () => navigate("/player/register"), "#166534")}
        {card("🏢", "Society / Organiser", "Manage players, enter scores, run competitions and view full results for your golf society.", "Organiser Login", () => navigate("/login"), "New society? Register here", () => navigate("/register"), "#2563eb")}
        {!isElectron && card("📍", "Golf Club", "Register your club's own details on GSM.", "Club Login", () => navigate("/login"), "New club? Register here", () => navigate("/register?type=club"), "#92400e")}
      </div>

      <p style={{ marginTop: "40px", fontSize: "11px", color: "#f0fdf4", cursor: "default", userSelect: "none" }}
        onClick={() => navigate("/superadmin")}>·</p>

      <div style={{ marginTop: "24px" }}>
        <LegalFooter />
      </div>
    </div>
  );
}
